import { useState, useEffect } from 'react';

function useDetectPrint() {
	const [isPrinting, toggleStatus] = useState(false);

	useEffect(() => {
		const media = matchMedia('print');

		const mediaQueryListEvent = (event: MediaQueryListEvent) => toggleStatus(!!event.matches);

		media.addEventListener('change', mediaQueryListEvent);

		return () => media.removeEventListener('change', mediaQueryListEvent);
	});

	return isPrinting;
}

export default useDetectPrint;
